import { render, staticRenderFns } from "./CalendarEventEditCard.vue?vue&type=template&id=962efc96"
import script from "./CalendarEventEditCard.vue?vue&type=script&lang=ts"
export * from "./CalendarEventEditCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('962efc96')) {
      api.createRecord('962efc96', component.options)
    } else {
      api.reload('962efc96', component.options)
    }
    module.hot.accept("./CalendarEventEditCard.vue?vue&type=template&id=962efc96", function () {
      api.rerender('962efc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarEventEditCard.vue"
export default component.exports